module.exports = __webpack_public_path__ + "img/MJ.8ea5cc87.png";